export const startDate = '20151213';
export const endDate = '20161210';



/** WEBPACK FOOTER **
 ** ./src/config.js
 **/